<template>
  <ImportLogs :is_safety_app="true" />
</template>

<script>
    const ImportLogs = () => import('@/views/import-logs/list.vue')

    export default {
        name: 'safety-app-import-logs',
        components: {
            ImportLogs
        }
    }
</script>